import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getProductDetail,
  updateProduct,
} from "../../../redux/actions/productActions";
import DefaultLayout from "../../../layouts/DefaultLayout";
import { toast } from "react-toastify";
import { getListSectionsByStore } from "../../../redux/actions/sectionActions";
import Select from "react-select";
import { getListStores } from "../../../redux/actions/storeActions";

function EditProductScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();

  //
  const [productName, setProductName] = useState("");
  const [productNameError, setProductNameError] = useState("");

  const [productImage, setProductImage] = useState("");
  const [productImageValue, setProductImageValue] = useState("");
  const [productImageError, setProductImageError] = useState("");

  const [productDescription, setProductDescription] = useState("");
  const [productDescriptionError, setProductDescriptionError] = useState("");

  const [productPrice, setProductPrice] = useState(0);
  const [productPriceError, setProductPriceError] = useState("");

  const [storeSelect, setStoreSelect] = useState("");
  const [storeSelectError, setStoreSelectError] = useState("");

  const [sectionSelect, setSectionSelect] = useState("");
  const [sectionSelectError, setSectionSelectError] = useState("");

  //
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const listStores = useSelector((state) => state.getListStores);
  const { stores, loadingListStores, errorListStores } = listStores;

  const listSectionsByStore = useSelector(
    (state) => state.getListSectionByStore
  );
  const { sections, loadingListSection, errorListSection, pages } =
    listSectionsByStore;

  const productDetail = useSelector((state) => state.detailProduct);
  const {
    loadingProductInfo,
    errorProductInfo,
    successProductInfo,
    productInfo,
  } = productDetail;

  const productUpdate = useSelector((state) => state.updateProduct);
  const { loadingProductUpdate, errorProductUpdate, successProductUpdate } =
    productUpdate;

  const redirect = "/";
  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    } else {
      dispatch(getListStores("0"));
      dispatch(getListSectionsByStore("0"));
      dispatch(getProductDetail(id));
    }
  }, [navigate, userInfo, dispatch, id]);

  useEffect(() => {
    if (productInfo && productInfo !== null && productInfo !== undefined) {
      setProductName(productInfo.product_name ?? "");
      if (productInfo.store) {
        var initialStore = productInfo.store.id ?? "";
        const foundStore = stores?.find((item) => item.id === initialStore);
        if (foundStore) {
          dispatch(getListSectionsByStore("0", foundStore.id));
          setStoreSelect({
            value: foundStore.id,
            label: foundStore.store_name,
          });
        } else {
          setStoreSelect("");
        }
      }

      setProductDescription(productInfo.product_description);
      setProductPrice(productInfo.product_price);
      if (productInfo.section) {
        var initialSection = productInfo.section.id ?? "";
        const foundSection = sections?.find(
          (item) => item.id === initialSection
        );
        console.log("foundSection");
        console.log(foundSection);
        if (foundSection) {
          console.log("foundSection");
          console.log(foundSection);

          setSectionSelect({
            value: foundSection.id,
            label: foundSection.section_name,
          });
        } else {
          setSectionSelect("");
        }
      }
    }
  }, [productInfo]);

  return (
    <DefaultLayout>
      <div>
        <div className="flex flex-row text-sm items-center my-1">
          {/* home */}
          <a href="/dashboard">
            <div className="flex flex-row  items-center hover:text-black ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                />
              </svg>
              <span className="mx-1">Dashboard</span>
            </div>
          </a>
          <a href="/products">
            <div className="flex flex-row  items-center hover:text-black ">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="w-4 h-4"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m8.25 4.5 7.5 7.5-7.5 7.5"
                  />
                </svg>
              </span>
              <div className="">Products List</div>
            </div>
          </a>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </span>
          <div className="">Edit Product</div>
        </div>
        {/*  */}
        <div className="py-5 px-4 flex justify-between">
          <h4 className=" uppercase font-semibold text-black dark:text-white">
            Edit Product
          </h4>
        </div>
        {/*  */}
        <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
          <div className="my-2 bg-white py-4 px-2 rounded-md">
            {/*  */}

            <div className="flex md:flex-row flex-col  ">
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Product Name <strong className="text-danger">*</strong>
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      productNameError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="text"
                    placeholder="Product Name"
                    value={productName}
                    onChange={(v) => setProductName(v.target.value)}
                  />
                  <div className=" text-[8px] text-danger">
                    {productNameError ? productNameError : ""}
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Product Price <strong className="text-danger">*</strong>
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      productPriceError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="number"
                    placeholder="Product Price"
                    min={0}
                    step={0.01}
                    value={productPrice}
                    onChange={(v) => setProductPrice(v.target.value)}
                  />
                  <div className=" text-[8px] text-danger">
                    {productPriceError ? productPriceError : ""}
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="flex md:flex-row flex-col  ">
              {/*  */}
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Select Store <strong className="text-danger">*</strong>
                </div>
                <div>
                  <Select
                    value={storeSelect}
                    onChange={(option) => {
                      setStoreSelect(option);
                      setSectionSelect("");
                      setSectionSelectError("");

                      // filter
                      if (option && option.value) {
                        dispatch(getListSectionsByStore("0", option.value));
                      } else {
                        dispatch({ type: "RESET_SECTION" });
                      }
                    }}
                    options={stores?.map((store) => ({
                      value: store.id,
                      label: store.store_name,
                    }))}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    className="text-sm"
                    placeholder="Select a Store..."
                    isSearchable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background: "#fff",
                        border: storeSelectError
                          ? "1px solid #d34053"
                          : "1px solid #979fd38a",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": {
                          border: "1px solid #979fd38a",
                        },
                      }),
                      option: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                      }),
                    }}
                  />
                  <div className=" text-[8px] text-danger">
                    {storeSelectError ? storeSelectError : ""}
                  </div>
                </div>
              </div>
              {/*  */}
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Select Section <strong className="text-danger">*</strong>{" "}
                  <strong className="text-danger">
                    <a href="/sections">( + create new )</a>
                  </strong>
                </div>
                <div>
                  <Select
                    value={sectionSelect}
                    onChange={(option) => {
                      setSectionSelect(option);
                      // filter
                    }}
                    options={sections?.map((store) => ({
                      value: store.id,
                      label: store.section_name,
                    }))}
                    filterOption={(option, inputValue) =>
                      option.label
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    className="text-sm"
                    placeholder="Select a Section..."
                    isSearchable
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background: "#fff",
                        border: sectionSelectError
                          ? "1px solid #d34053"
                          : "1px solid #979fd38a",
                        boxShadow: state.isFocused ? "none" : "none",
                        "&:hover": {
                          border: "1px solid #979fd38a",
                        },
                      }),
                      option: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                      }),
                    }}
                  />
                  <div className=" text-[8px] text-danger">
                    {sectionSelectError ? sectionSelectError : ""}
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="flex md:flex-row flex-col  ">
              <div className=" w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Product Description <strong className="text-danger">*</strong>
                </div>
                <div>
                  <textarea
                    rows={5}
                    className={` outline-none border ${
                      productDescriptionError
                        ? "border-danger"
                        : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    value={productDescription}
                    onChange={(v) => setProductDescription(v.target.value)}
                  ></textarea>

                  <div className=" text-[8px] text-danger">
                    {productDescriptionError ? productDescriptionError : ""}
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="flex md:flex-row flex-col  ">
              <div className="md:w-1/2 w-full  md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs  mb-1">
                  Product Image
                </div>
                <div>
                  <input
                    className={` outline-none border ${
                      productImageError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    type="file"
                    placeholder="First Name"
                    value={productImageValue}
                    onChange={(v) => {
                      setProductImageValue(v.target.value);
                      setProductImage(v.target.files[0]);
                    }}
                  />
                  <div className=" text-[8px] text-danger">
                    {productImageError ? productImageError : ""}
                  </div>
                </div>
              </div>
            </div>
            {/*  */}
            <div className="my-3 ">
              <div className="flex flex-row items-center justify-end my-3">
                <a
                  href="/products"
                  className="bg-white text-[#0388A6] text-sm px-5 py-3 rounded-full mr-3"
                >
                  Back
                </a>
                <button
                  disabled={loadingProductUpdate}
                  onClick={async () => {
                    var check = true;
                    setProductNameError("");
                    setProductImageError("");
                    setProductDescriptionError("");
                    setProductPriceError("");
                    setStoreSelectError("");
                    setSectionSelectError("");

                    if (productName === "") {
                      setProductNameError("These fields are required.");
                      check = false;
                    }
                    if (productDescription === "") {
                      setProductDescriptionError("These fields are required.");
                      check = false;
                    }
                    if (productPrice === "") {
                      setProductPriceError("These fields are required.");
                      check = false;
                    }
                    if (storeSelect === "" || storeSelect.value === "") {
                      setStoreSelectError("This field is required.");
                      check = false;
                    }

                    if (sectionSelect === "" || sectionSelect.value === "") {
                      setSectionSelectError("This field is required.");
                      check = false;
                    }

                    if (check) {
                      // setLoadEvent(true);
                      await dispatch(
                        updateProduct(id, {
                          product_name: productName,
                          product_image: productImage,
                          product_store: storeSelect.value,
                          product_section: sectionSelect.value,
                          product_description: productDescription,
                          product_price: productPrice,
                        })
                      ).then(() => {});
                      // setLoadEvent(false);
                    } else {
                      toast.error(
                        "Some fields are empty or invalid. please try again"
                      );
                    }
                  }}
                  className="text-white bg-[#0388A6] text-sm px-5 py-3 rounded-full"
                >
                  {loadingProductUpdate ? "Loading ..." : "Update Product"}
                </button>
              </div>
            </div>

            {/*  */}
          </div>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default EditProductScreen;
